import React, { Fragment } from 'react';
import styled from 'react-emotion';
import { SelectableListItem, StyledCheck } from '../Components';
import Quantity from './Quantity';
const ListItem = styled('p') `
  font-size: ${({ theme }) => theme.fontSizes[1]};
  margin-left: ${({ theme }) => theme.space[2]};
`;
const ListItemWrapper = styled('span') `
  display: flex;
  flex-direction: row;
`;
const MultiSelectList = ({ items, getItemProps, selectedItems, highlightedIndex }) => {
    return (React.createElement(Fragment, null, items.map((item, index) => {
        const active = selectedItems.some(currentItem => currentItem.value === item.value);
        return (React.createElement(SelectableListItem, Object.assign({ type: "button", key: index, disabled: !item.resultCount || item.resultCount <= 0, isHighlighted: highlightedIndex === index }, getItemProps({
            item: item,
            index,
            isSelected: active
        })),
            React.createElement(ListItemWrapper, null,
                React.createElement(ListItem, null, item.text || item.value),
                item.resultCount !== null ? (React.createElement(Quantity, null,
                    " (",
                    item.resultCount,
                    ")")) : null),
            active && React.createElement(StyledCheck, null)));
    })));
};
export default MultiSelectList;
//# sourceMappingURL=MultiSelectList.js.map